import { render, staticRenderFns } from "./Equipos&Accesorios.vue?vue&type=template&id=798e9e97&scoped=true&"
import script from "./Equipos&Accesorios.vue?vue&type=script&lang=js&"
export * from "./Equipos&Accesorios.vue?vue&type=script&lang=js&"
import style0 from "./Equipos&Accesorios.vue?vue&type=style&index=0&id=798e9e97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798e9e97",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VDivider,VPagination,VRow})
